import { render, staticRenderFns } from "./FeaturedContent.vue?vue&type=template&id=2be6c118&"
import script from "./FeaturedContent.vue?vue&type=script&lang=js&"
export * from "./FeaturedContent.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports